'use client';

import { c as _c } from "react/compiler-runtime";
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { signOut } from 'next-auth/react';
import { useUser } from '@/app/_shared/hooks/useUser';
import { insertLCTConfig } from '@/app/init_db';
import { seedInitialLookupValues } from '@/app/seed_lookup';
import { seedOverheadRate } from '@/app/seed_overhead_rate';
import { seedCostSheetTargets } from '@/app/seed_cost_sheet_targets';
import { DateText } from '@/app/_shared/components/DateText';
import { useBrowserTimeZone } from '@/app/_shared/hooks/useBrowserTimeZone';
export const UserMenu: React.FC = () => {
  const $ = _c(33);
  const {
    name,
    avatarUrl,
    lastLoginAt
  } = useUser();
  const [anchorElUser, setAnchorElUser] = useState(null);
  const timeZone = useBrowserTimeZone();
  let t0;
  let t1;
  if ($[0] !== name) {
    const [firstName, lastName] = name.split(" ");
    t0 = firstName?.at(0) as string;
    t1 = lastName?.at(0);
    $[0] = name;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  const initials = t0 + t1 as string;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = event => {
      setAnchorElUser(event.currentTarget);
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleOpenUserMenu = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setAnchorElUser(null);
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleCloseUserMenu = t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      flexGrow: 0
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      p: 0
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = name || "Avatar";
  const t7 = avatarUrl || undefined;
  const t8 = name ? initials : null;
  let t9;
  if ($[7] !== t6 || $[8] !== t7 || $[9] !== t8) {
    t9 = <Tooltip title="Open settings"><IconButton onClick={handleOpenUserMenu} sx={t5}><Avatar alt={t6} src={t7} variant="rounded" sx={_temp}>{t8}</Avatar></IconButton></Tooltip>;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      mt: 6
    };
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      vertical: "top",
      horizontal: "right"
    };
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      vertical: "top",
      horizontal: "right"
    };
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  const t13 = Boolean(anchorElUser);
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <MenuItem sx={{
      display: "none"
    }} onClick={_temp2}>Insert LCT Config</MenuItem>;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <MenuItem sx={{
      display: "none "
    }} onClick={_temp3}>Seed Lookup Values</MenuItem>;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <MenuItem sx={{
      display: "none"
    }} onClick={_temp4}>Seed Overhead Rate</MenuItem>;
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  let t17;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <MenuItem sx={{
      display: "none"
    }} onClick={_temp5}>Seed Cost Sheet Targets</MenuItem>;
    $[17] = t17;
  } else {
    t17 = $[17];
  }
  let t18;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <MenuItem onClick={_temp6} divider={true}><Typography textAlign="center">Log out</Typography></MenuItem>;
    $[18] = t18;
  } else {
    t18 = $[18];
  }
  let t19;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = {
      pb: 0
    };
    $[19] = t19;
  } else {
    t19 = $[19];
  }
  let t20;
  if ($[20] !== lastLoginAt) {
    t20 = <MenuItem disabled={true} sx={t19}><Typography fontSize={13}>Last Login: <DateText value={lastLoginAt} withTime={true} /></Typography></MenuItem>;
    $[20] = lastLoginAt;
    $[21] = t20;
  } else {
    t20 = $[21];
  }
  let t21;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = {
      pt: 0
    };
    $[22] = t21;
  } else {
    t21 = $[22];
  }
  let t22;
  if ($[23] !== timeZone) {
    t22 = <MenuItem disabled={true} sx={t21}><Typography fontSize={13}>Times shown in {timeZone}</Typography></MenuItem>;
    $[23] = timeZone;
    $[24] = t22;
  } else {
    t22 = $[24];
  }
  let t23;
  if ($[25] !== anchorElUser || $[26] !== t13 || $[27] !== t20 || $[28] !== t22) {
    t23 = <Menu sx={t10} id="menu-appbar" anchorEl={anchorElUser} anchorOrigin={t11} keepMounted={true} transformOrigin={t12} open={t13} onClose={handleCloseUserMenu}>{t14}{t15}{t16}{t17}{t18}{t20}{t22}</Menu>;
    $[25] = anchorElUser;
    $[26] = t13;
    $[27] = t20;
    $[28] = t22;
    $[29] = t23;
  } else {
    t23 = $[29];
  }
  let t24;
  if ($[30] !== t23 || $[31] !== t9) {
    t24 = <><Box sx={t4}>{t9}{t23}</Box></>;
    $[30] = t23;
    $[31] = t9;
    $[32] = t24;
  } else {
    t24 = $[32];
  }
  return t24;
};
function _temp(t0) {
  const {
    palette,
    shadows
  } = t0;
  return {
    width: 40,
    height: 40,
    backgroundColor: palette.primary.main,
    boxShadow: shadows[1]
  };
}
function _temp2() {
  return insertLCTConfig();
}
function _temp3() {
  return seedInitialLookupValues();
}
function _temp4() {
  return seedOverheadRate();
}
function _temp5() {
  return seedCostSheetTargets();
}
function _temp6() {
  return signOut();
}